/**
 * Global JS entry – runs on every page.
 * Add new entry files in src/js/entry/ for page-specific bundles.
 */

import index from '../objects/global';

index();
